"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const accordionTabs = {
    isMobile: function () {
        return window.innerWidth < 1056;
    },
    init: function (el) {
        console.log('init accordionTabs');
        const tabs = el.querySelectorAll('details');
        tabs.forEach((tab) => {
            const summary = tab.querySelector('summary');
            summary?.addEventListener('click', (e) => {
                // Tabs view is only on screens md and up
                if (!this.isMobile()) {
                    if (tab.hasAttribute('open')) {
                        e.preventDefault();
                    }
                    else {
                        tabs.forEach((t) => {
                            if (t !== tab) {
                                t.removeAttribute('open');
                            }
                        });
                    }
                }
            });
        });
    }
};
exports.default = accordionTabs;
